module.exports = __webpack_public_path__ + "img/choose-your-forex.2d76e3dc.png";